import React from 'react';
import I18n from 'i18n-js';
import track, { TrackingProp } from 'react-tracking';

import ListingCard from '@reverbdotcom/commons/src/components/listing_card';
import { LISTING_TYPE } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

import { Listing } from '../../schemas/rql';

import ErrorDisplay from '../discovery/error_display';
import { PageSettings } from './map_params';
import NotFoundAnimation from '../not_found_animation';
import TileCurationView from '../discovery/curation/tile_curation_view';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

interface ExternalProps {
  loading: boolean;
  error: boolean;
  listings: Listing[];
  showingSold: boolean;
  tracking?: TrackingProp;
  trackingName?: string;
  emptyGrid?: JSX.Element;
  trackingQuery?: string;
  pageSettings?: PageSettings;
}

type IProps = ExternalProps & IUserContext;

export const BRAND_NEW_CONDITION_UUID = '7c3f45de-2ae0-4c81-8400-fdb6b1d74890';

const trackingContext = {
  componentName: 'GridView',
  type: LISTING_TYPE,
};

export function GridEmptyState() {
  return (
    <div className="not-found">
      <h3 className="not-found__message">
        {I18n.t('discovery.noResults.nothingHere')}
      </h3>
      <NotFoundAnimation />
    </div>
  );
}

export function ListingGrid(props: IProps) {
  if (props.error) {
    return <ErrorDisplay />;
  }

  return (
    <Tiles
      fourWideMax
      placeholder={<ListingCard />}
      expectedCount={24}
      emptyState={props.emptyGrid || GridEmptyState()}
      loading={props.loading}
    >
      {props.listings.map((listing, idx) => {
        return (
          <ListingCard
            key={listing.id}
            listing={listing}
            position={idx}
            soldListing={props.showingSold}
            trackingName={props.trackingName}
            trackingQuery={props.trackingQuery}
            footerContent={
              props.user.isAdmin &&
              <TileCurationView
                listingId={listing.id}
                pageSettings={props.pageSettings}
                bumped={listing.bumped}
              />
            }
          />
        );
      })}
    </Tiles>
  );
}

export default withUserContext<IProps>(track(trackingContext)(ListingGrid));
